import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GeneralScheduleComponentScheduleForEventQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GeneralScheduleComponentScheduleForEventQuery = {
  __typename?: 'Query';
  getGuestGeneralEventScheduleForEvent: {
    __typename?: 'GeneralEventScheduleInfo';
    id: string;
    formattedSchedules: Array<{
      __typename?: 'FormattedSchedule';
      id: string;
      dateISO8601TZ: string;
      items: Array<{
        __typename?: 'EventSchedule';
        description?: string | null;
        firebaseKey?: string | null;
        id: string;
        isMain: boolean;
        isPublic: boolean;
        name: string;
        timezone?: string | null;
        startTimeISO8601TZ?: string | null;
        endTimeISO8601TZ?: string | null;
        dressCode?: string | null;
        location?: string | null;
        showMap: boolean;
        placeId?: string | null;
        locationInfo?: {
          __typename?: 'EventLocation';
          id?: string | null;
          placeId?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          name?: string | null;
          address1?: string | null;
          address2?: string | null;
          city?: string | null;
          state?: string | null;
          country?: string | null;
          postalCode?: string | null;
        } | null;
      }>;
    }>;
    tbaSchedules: Array<{
      __typename?: 'EventSchedule';
      description?: string | null;
      firebaseKey?: string | null;
      id: string;
      isMain: boolean;
      isPublic: boolean;
      name: string;
      timezone?: string | null;
      startTimeISO8601TZ?: string | null;
      endTimeISO8601TZ?: string | null;
      dressCode?: string | null;
      location?: string | null;
      showMap: boolean;
      placeId?: string | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        placeId?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        name?: string | null;
        address1?: string | null;
        address2?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        postalCode?: string | null;
      } | null;
    }>;
  };
};

export const GeneralScheduleComponentScheduleForEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GeneralScheduleComponentScheduleForEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getGuestGeneralEventScheduleForEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'formattedSchedules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateISO8601TZ' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firebaseKey' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isMain' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startTimeISO8601TZ' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTimeISO8601TZ' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dressCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'showMap' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'locationInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tbaSchedules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firebaseKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMain' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTimeISO8601TZ' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTimeISO8601TZ' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dressCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showMap' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locationInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGeneralScheduleComponentScheduleForEventQuery__
 *
 * To run a query within a React component, call `useGeneralScheduleComponentScheduleForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralScheduleComponentScheduleForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralScheduleComponentScheduleForEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGeneralScheduleComponentScheduleForEventQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GeneralScheduleComponentScheduleForEventQuery, GeneralScheduleComponentScheduleForEventQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GeneralScheduleComponentScheduleForEventQuery, GeneralScheduleComponentScheduleForEventQueryVariables>(
    GeneralScheduleComponentScheduleForEventDocument,
    baseOptions,
  );
}
export function useGeneralScheduleComponentScheduleForEventLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GeneralScheduleComponentScheduleForEventQuery, GeneralScheduleComponentScheduleForEventQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GeneralScheduleComponentScheduleForEventQuery, GeneralScheduleComponentScheduleForEventQueryVariables>(
    GeneralScheduleComponentScheduleForEventDocument,
    baseOptions,
  );
}
export type GeneralScheduleComponentScheduleForEventQueryHookResult = ReturnType<typeof useGeneralScheduleComponentScheduleForEventQuery>;
export type GeneralScheduleComponentScheduleForEventLazyQueryHookResult = ReturnType<typeof useGeneralScheduleComponentScheduleForEventLazyQuery>;
export type GeneralScheduleComponentScheduleForEventQueryResult = Apollo.QueryResult<
  GeneralScheduleComponentScheduleForEventQuery,
  GeneralScheduleComponentScheduleForEventQueryVariables
>;
